import { REQUIRED_FIELD } from '@/utils/validationMessagesUtils'

export default {
  selectedSweepstakeRecurrenceErrors () {
    const errors = []
    if (!this.$v.selectSweepstake.$dirty) return errors
    !this.$v.selectSweepstake.required && errors.push(REQUIRED_FIELD)
    return errors
  }
}